import React, { useState, useEffect } from "react";
import HomePageNavBar from "../Components/HomePageNavBar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getFavoriteListings } from "../Services/favoritesApi";
import {
  sortByTitleAZ,
  sortByTitleZA,
  sortLatestFirst,
  sortOldestFirst,
} from "../Services/helper";
import Footer from "../Components/Footer";
import ListingsCard from "../Components/ListingsCard";

import LocationBarAllListings from "../Components/LocationBarAllListings";
import CITYDEFAULTIMAGE from "../assets/CityDefault.png";

const Favorites = () => {
  window.scrollTo(0, 0);
  const pageSize = window.innerWidth <= 768 ? 8 : 12;
  const { t } = useTranslation();
  const [pageNo, setPageNo] = useState(1);
  const [selectedSortOption, setSelectedSortOption] = useState("");
  const [favListings, setFavListings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const searchParams = new URLSearchParams(location.search);
  const terminalViewParam = searchParams.get("terminalView");
  const [terminalView, setTerminalView] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const isTerminalScreenEnvEnabled =
    process.env.REACT_APP_ENABLE_TERMINALSCREEN === "True";

  const isTerminalScreenEnabled = isTerminalScreenEnvEnabled && terminalViewParam === "true";

  const fetchData = () => {
    const params = { pageSize: 12, statusId: 1 };
    setIsLoading(true);
    getFavoriteListings(params)
      .then((response) => {
        const data = response.data.data;
        setFavListings(data);
      })
      .catch((error) => console.error("Error fetching favorite listings:", error))
      .finally(() => {
        setTimeout(() => setIsLoading(false), 1000);
      });
  };


  useEffect(() => {
    const accessToken =
      window.localStorage.getItem("accessToken") ||
      window.sessionStorage.getItem("accessToken");
    const refreshToken =
      window.localStorage.getItem("refreshToken") ||
      window.sessionStorage.getItem("refreshToken");
    if (!accessToken && !refreshToken) {
      window.location.href = "/login";
    }
    document.title = process.env.REACT_APP_REGION_NAME;
  }, []);

  useEffect(() => {
    setTerminalView(isTerminalScreenEnabled);
    fetchData();
  }, [searchQuery, pageNo]);

  useEffect(() => {
    fetchData();
  }, [pageNo, t]);

  useEffect(() => {
    switch (selectedSortOption) {
      case "titleAZ":
        setFavListings([...sortByTitleAZ(favListings)]);
        break;
      case "titleZA":
        setFavListings([...sortByTitleZA(favListings)]);
        break;
      case "recent":
        setFavListings([...sortLatestFirst(favListings)]);
        break;
      case "oldest":
        setFavListings([...sortOldestFirst(favListings)]);
        break;
      default:
        break;
    }
  }, [selectedSortOption]);

  const navigate = useNavigate();
  const navigateTo = (path) => {
    if (path) {
      navigate(path);
    }
  };

  const onSearch = (term) => {
    setSearchQuery(term);
  };

  function goBack() {
    navigateTo(`/`);
  }

  return (
    <section className="text-gray-900 body-font relative">
      <HomePageNavBar showBlackLogo/>{" "}

      <div className="container-fluid py-0 mr-0 ml-0 mt-0 w-full flex flex-col relative">
        <div className="w-full mr-0 ml-0">
          <div className="h-[20rem] lg:h-full overflow-hidden px-0 py-0 relative">
            <div className="relative h-[20rem]">
              <img
                alt="ecommerce"
                className="object-cover object-center h-full w-full"
                src={CITYDEFAULTIMAGE}
                loading="lazy"
              />

              <div className="absolute inset-0 flex flex-col gap-4 items-center justify-center bg-gray-800 bg-opacity-75 text-white z--1">
                <div className="w-full px-5 md:px-10 lg:px-[10rem] 2xl:px-[20rem] mx-auto flex justify-center">
                  <div className="w-full max-w-7xl">
                    <LocationBarAllListings
                      onSearch={onSearch}
                      searchQuery={searchQuery}
                      selectedSortOption={selectedSortOption}
                      onSortChange={setSelectedSortOption}
                      refreshListings={fetchData}
                      terminalView={terminalView}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 mb-20 p-6">
        {isLoading ? (
          <div className="bg-white lg:px-10 md:px-5 px-2 py-5 mt-5 mb-5 space-y-10 flex flex-col">
            <div className="relative place-items-center bg-white mb-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 gap-10 justify-start">
              {Array.from({ length: 10 }).map((_, index) => (
                <div
                  key={index}
                  className="flex flex-col space-y-4 rounded-lg border border-gray-200 p-4 animate-pulse w-full"
                >
                  <div className="w-full h-48 bg-gray-200 rounded"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            {favListings && favListings.length > 0 ? (
              <div className="bg-white lg:px-10 md:px-5 px-2 py-5 mt-5 mb-5 space-y-10 flex flex-col">
                <div className="relative place-items-center bg-white mb-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 gap-10 justify-start">
                  {favListings &&
                    favListings.map((favListing, index) => (
                      <ListingsCard listing={favListing} key={index} terminalView={terminalViewParam} />
                    ))}
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center min-h-[40vh] px-6">
                <h2 className="mb-6 text-4xl font-bold">
                  {t("currently_no_listings")}
                </h2>
                <p className="text-lg text-gray-600">
                  {t("selectOtherCityorCategory")}
                </p>
                <button
                  onClick={goBack}
                  className="mt-10 px-6 py-3 bg-gray-700 text-white rounded-full hover:scale-105 transition"
                >
                  {t("goBack")}
                </button>
              </div>
            )}
          </>
        )}

        {favListings.length > 0 && (
          <div
            className={`mt-20 mb-20 rounded-xl w-fit mx-auto 
      bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg
      hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out`}
          >
            {pageNo > 1 && (
              <span
                className="text-lg px-3 cursor-pointer"
                style={{
                  fontFamily:
                    "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                }}
                onClick={() => setPageNo(pageNo - 1)}
              >
                {"<"}
              </span>
            )}

            <span
              className="text-lg px-3"
              style={{
                fontFamily:
                  "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
              }}
            >
              {t("page")} {pageNo}
            </span>

            {favListings.length === pageSize && (
              <span
                className="text-lg px-3 cursor-pointer rounded-lg"
                style={{
                  fontFamily:
                    "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                }}
                onClick={() => setPageNo(pageNo + 1)}
              >
                {">"}
              </span>
            )}
          </div>
        )}
      </div>

      {!isLoading && (
        <div className="bottom-0 w-full">
          <Footer />
        </div>
      )}
    </section>
  );
};

export default Favorites;
